import { StatusesMetadata } from '@common/models';

export const BackItsmFeatureKey = 'itsm';

export interface IBackItsmState extends StatusesMetadata
{
    subEntities: string[];
    ressources: string;
}

export const BackItsmInitialState: IBackItsmState = {
    subEntities: [],
    isLoading: false,
    isLoaded: false,
    isEmpty: false,
    isOups: false,
    ressources: '',
    expirationDate: null
};
